import UserProperties from './UserProperties'

export default UserProperties
